import {
  CsvExport,
  ExcelExport,
  ExcelSheet,
} from '../models/api/core/export/export';

export class TreatmentExportMapper {
  static toCsvExport(rows: any[], fileName: string): CsvExport {
    const headers = [
      'Starting Date',
      'Ending Date',
      'Code',
      'Description',
      'Units Requested',
      'Units Approved',
    ];

    const dataRows = rows.map((row) => [
      this.formatDate(row.startingDate),
      this.formatDate(row.endingDate),
      row.code || '',
      row.description || '',
      row.unitsRequested ?? '',
      row.unitsApproved ?? '',
    ]);

    return {
      fileName,
      headers,
      rows: dataRows,
    };
  }

  static toExcelExport(
    rows: any[],
    fileName: string,
    sheetLabel: string,
  ): ExcelExport {
    const headers = [
      'Starting Date',
      'Ending Date',
      'Code',
      'Description',
      'Units Requested',
      'Units Approved',
    ];

    const dataRows = rows.map((row) => [
      this.formatDate(row.startingDate),
      this.formatDate(row.endingDate),
      row.code || '',
      row.description || '',
      row.unitsRequested ?? '',
      row.unitsApproved ?? '',
    ]);

    const sheet: ExcelSheet = {
      label: sheetLabel,
      headers,
      rows: dataRows,
    };

    return {
      fileName,
      sheets: [sheet],
    };
  }

  private static formatDate(value: any): string {
    if (!value) return '';
    if (value === '0001-01-01T00:00:00') return '';
    const d = new Date(value);
    if (!isNaN(d.getTime())) {
      return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
    }
    return '';
  }
}
